import { Flex, type GridRowSelectionModel, Text } from '@shared/components';
import { useState } from 'react';

import { BaseExamAssigningDataGrid } from '../../components';
import { useExamDistributionByMonth } from '../../providers';

import { columns } from './columns';

interface ExamAssigningListProps {
  onSelectRow?: (selectedExamCourseIds: string[]) => void;
}

export default function ExamAssigningList(props: Readonly<ExamAssigningListProps>) {
  const { onSelectRow } = props;

  const { examDistributionData, isLoading } = useExamDistributionByMonth();
  const [selectedExamCoursesCount, setSelectedExamCoursesCount] = useState(0);
  const { examCourses } = examDistributionData;

  const handleRowSelectionChange = (rowSelectionModel: GridRowSelectionModel) => {
    const selectedExamCourses = rowSelectionModel as string[];
    setSelectedExamCoursesCount(selectedExamCourses.length);
    onSelectRow?.(selectedExamCourses);
  };

  const rows =
    examCourses
      .map((examCourse) => ({
        ...examCourse,
        id: examCourse.code,
      }))
      .sort((a, b) => a.examId - b.examId) ?? [];

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <Text variant='h4'>เลือกหลักสูตรที่ต้องการมอบหมายชุดข้อสอบ ({selectedExamCoursesCount})</Text>
      <BaseExamAssigningDataGrid
        columns={columns}
        rows={rows}
        loading={isLoading}
        hideFooter={true}
        onRowSelectionModelChange={handleRowSelectionChange}
      />
    </Flex>
  );
}
